import { Component, Input } from '@angular/core';
import { IDropdownButton } from '@common/interfaces/header-menu.interface';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
})
export class HeaderMenuComponent  {

  @Input() menuDropdown: IDropdownButton[];
  @Input() currentRoute: string;

  constructor() {}

  public isCurrentRoute(item: IDropdownButton): boolean {
    return item.dropdownLinks ?
      item.dropdownLinks.some((inner) => this.findRoute(inner.route)):
      this.findRoute(item.route);
  }

  private findRoute(route: string) {
    return this.currentRoute === `/${route}`;
  }

}
